'use client';

import { useCallback } from 'react';

const base64UrlEncode = (buffer: ArrayBuffer) =>
    btoa(String.fromCharCode(...new Uint8Array(buffer)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

/**
 * Kick OAuth (PKCE) redirect. Shared by every "Login with Kick" entry point.
 */
export function useKickLogin() {
    return useCallback(async () => {
        const codeVerifier = crypto.randomUUID();
        const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
        const codeChallenge = base64UrlEncode(hash);
        const state = crypto.randomUUID();

        localStorage.setItem('kick_code_verifier', codeVerifier);
        localStorage.setItem('kick_oauth_state', state);

        window.location.href = `${process.env.NEXT_PUBLIC_API_URL}auth/kick/redirect?state=${state}&code_challenge=${codeChallenge}&code_verifier=${codeVerifier}`;
    }, []);
}
